import httpService from "../../http/requests/app"


export default {
  state: {

  },

  getters: {

  },
  mutations: {

  },

  actions: {

    getLoyaltyTransactions({commit}, filterData){

      return new Promise((resolve,reject) => {
        httpService.getTransactions(filterData)
          .then(response => {

            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });
    },
      getBonusTransactions({commit}, filterData) {
          return new Promise((resolve,reject) => {
              httpService.getBonusTransactions(filterData)
                  .then(response => {

                      resolve(response.data);


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      getNonAccrualTransactions({commit}, filterData) {
          return new Promise((resolve,reject) => {
              httpService.getNonAccrualTransactions(filterData)
                  .then(response => {

                      resolve(response.data);


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      getRule({commit}, ruleData){
          return new Promise((resolve,reject) => {
              httpService.getRule(ruleData.id)
                  .then(response => {

                      resolve(response.data);


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      getFraudRules({commit}) {
          return new Promise((resolve,reject) => {
              httpService.getFraudRules()
                  .then(response => {
                      resolve(response.data);
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      getFraudRule({commit}, ruleData) {
          return new Promise((resolve,reject) => {
              httpService.getFraudRule(ruleData.id)
                  .then(response => {
                      resolve(response.data);
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      downloadInvoiceStatement({commit}, invoiceData){
          return new Promise((resolve,reject) => {
              httpService.downloadInvoiceStatement(invoiceData.invoiceId)
                  .then(response => {

                      resolve(response.data);


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      getOutletPerformance({commit}, filterData){
          return new Promise((resolve,reject) => {
              httpService.getOutletPerformance(filterData.startDate, filterData.endDate, filterData.transactionType)
                  .then(response => {

                      resolve(response.data);


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      getCustomerPerformance({commit}, filterData) {
          return new Promise((resolve,reject) => {
              httpService.getCustomerPerformance(filterData.startDate, filterData.endDate, filterData.transactionType, filterData.limit)
                  .then(response => {

                      resolve(response.data);


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      getLoyaltyQuickStats({commit}){
          return new Promise((resolve,reject) => {
              httpService.getLoyaltyQuickStats()
                  .then(response => {
                      resolve(response.data);
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },

    getParkingTransactions({commit}, filterData){

      return new Promise((resolve,reject) => {
        httpService.getParkingTransactions(filterData)
          .then(response => {

            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });

    },

    exportParkingTransactions({commit}, filterData){
      return new Promise((resolve,reject) => {
        httpService.exportParkingTransactions(filterData)
          .then(response => {

            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });
    },



    exportTransactionsData({commit}, filterData){
      return new Promise((resolve,reject) => {
        httpService.exportTransactionsData(filterData)
          .then(response => {

            if(response.data.statusCode == 200){

              resolve();

            }
            else{
              reject({message: response.data.message})
            }



          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });
    },
      exportBonusTransactions({commit},filterData) {
          return new Promise((resolve,reject) => {
              httpService.exportBonusTransactions(filterData)
                  .then(response => {

                      if(response.data.statusCode == 200){
                          resolve();
                      }
                      else{
                          reject({message: response.data.message})
                      }



                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
    getCustomerTransactions({commit}, filterData){
      return new Promise((resolve,reject) => {
        httpService.getCustomerTransactions(filterData)
          .then(response => {


            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });
    },
    getLotteryTransactions({commit}, filterData){

      return new Promise((resolve,reject) => {
        httpService.getLotteryTransactions(filterData)
          .then(response => {

            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });
    },
      getRules() {
          return new Promise((resolve,reject) => {
              httpService.getRules()
                  .then(response => {
                      resolve(response.data);

                  })
                  .catch(error => {
                      //reject({message: axios.defaults.headers})
                  })
          });
      },
    getCustomerDetailsByPhoneNumber({commit}, customerData){
      return new Promise((resolve,reject) => {
        httpService.getCustomerDetailsByPhoneNumber(customerData.phoneNumber)
            .then(response => {

              resolve(response.data);


            })
            .catch(error => {

              //reject({message: axios.defaults.headers})
            })
      });
    },
    getLoyaltyStats({commit}){

      return new Promise((resolve,reject) => {
        httpService.getLoyaltyStats()
          .then(response => {

            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });

    },
    getMerchantStats({commit}, outletData){
      return new Promise((resolve,reject) => {
        httpService.getMerchantStats(outletData.id)
          .then(response => {

            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });
    },
    getLotteryStats({commit}){

      return new Promise((resolve,reject) => {
        httpService.getLotteryStats()
          .then(response => {

            resolve(response.data);


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });

    },
      getReportExports() {
          return new Promise((resolve,reject) => {
              httpService.getReportExports()
                  .then(response => {
                      resolve(response.data);
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
    awardCustomerPointsWebPortal({commit}, payloadData){
      return new Promise((resolve,reject) => {
        httpService.awardPoints(payloadData)
            .then(response => {

              if(response.data.statusCode == 200){

                resolve()

              }
              else{
                reject({message: response.data.message})
              }


            })
            .catch(error => {

              //reject({message: axios.defaults.headers})
            })
      });
    },

      clearInvoices({commit}){
          return new Promise((resolve,reject) => {
              httpService.clearInvoices()
                  .then(response => {

                      if(response.data.statusCode == 200){

                          resolve()

                      }
                      else{
                          reject({message: response.data.message})
                      }


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      updateRuleStatus({commit}, ruleData) {
          return new Promise((resolve,reject) => {
              httpService.updateRuleStatus(ruleData)
                  .then(response => {
                      if(response.data.statusCode == 200){
                          resolve()
                      }
                      else{
                          reject({message: response.data.message})
                      }
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      updateFraudRuleStatus({commit}, ruleData) {
          return new Promise((resolve,reject) => {
              httpService.updateFraudRuleStatus(ruleData)
                  .then(response => {
                      if(response.data.statusCode == 200){
                          resolve()
                      }
                      else{
                          reject({message: response.data.message})
                      }
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      generateBulkInvoice({commit}, payload){
          return new Promise((resolve,reject) => {
              httpService.generateBulkInvoice(payload.transactionType)
                  .then(response => {

                      if(response.data.statusCode == 200){

                          resolve()

                      }
                      else{
                          reject({message: response.data.message})
                      }


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      exportInvoices({commit}, payload){
          return new Promise((resolve,reject) => {
              httpService.exportInvoices(payload.startDate, payload.endDate, payload.invoiceType)
                  .then(response => {

                      if(response.data.statusCode == 200){
                          resolve(response.data)
                      }
                      else{
                          reject({message: response.data.message})
                      }
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      createRule({commit}, payload) {
          return new Promise((resolve,reject) => {
              httpService.createRule(payload)
                  .then(response => {

                      if(response.data.statusCode == 200){
                          resolve(response.data)
                      }
                      else{
                          reject({message: response.data.message})
                      }
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      editRule({commit}, payload) {
          return new Promise((resolve,reject) => {
              httpService.editRule(payload)
                  .then(response => {

                      if(response.data.statusCode == 200){
                          resolve(response.data)
                      }
                      else{
                          reject({message: response.data.message})
                      }
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      resendNetsuiteInvoice({commit}, payload){
          return new Promise((resolve,reject) => {
              httpService.resendNetsuiteInvoice(payload.id)
                  .then(response => {

                      if(response.data.statusCode == 200){
                          resolve(response.data)
                      }
                      else{
                          reject({message: response.data.message})
                      }
                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },

      redeemPointsWebPortal({commit}, payloadData){
          return new Promise((resolve,reject) => {
              httpService.redeemPoints(payloadData)
                  .then(response => {

                      if(response.data.statusCode == 200){

                          resolve()

                      }
                      else{
                          reject({message: response.data.message})
                      }


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      createFraudRule({commit}, payloadData) {
          return new Promise((resolve,reject) => {
              httpService.createFraudRule(payloadData)
                  .then(response => {

                      if(response.data.statusCode == 200){

                          resolve()

                      }
                      else{
                          reject({message: response.data.message})
                      }


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },
      editFraudRule({commit}, payloadData) {
          return new Promise((resolve,reject) => {
              httpService.editFraudRule(payloadData)
                  .then(response => {

                      if(response.data.statusCode == 200){

                          resolve()

                      }
                      else{
                          reject({message: response.data.message})
                      }


                  })
                  .catch(error => {

                      //reject({message: axios.defaults.headers})
                  })
          });
      },

    reverseTransaction({commit}, payloadData){
      return new Promise((resolve,reject) => {
        httpService.reverseTransaction(payloadData)
          .then(response => {

            if(response.data.statusCode == 200){

              resolve()

            }
            else{
              reject({message: response.data.message})
            }


          })
          .catch(error => {

            //reject({message: axios.defaults.headers})
          })
      });
    },

    getEPurseTransfers({commit}, params) {
      return new Promise((resolve, reject) => {
        httpService.getEPurseTransfers(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      });
    },

    approveEPurseTransfer({commit}, approvalData) {
      return new Promise((resolve, reject) => {
        httpService.approveEPurseTransfer(approvalData)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      });
    },

    getRedemptionApprovals({commit}, params) {
      return new Promise((resolve, reject) => {
        httpService.getRedemptionApprovals(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      });
    },

    approveRedemption({commit}, approvalData) {
      return new Promise((resolve, reject) => {
        httpService.approveRedemption(approvalData)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      });
    },

    getVoucherRedemptionApprovals({commit}, params) {
      return new Promise((resolve, reject) => {
        httpService.getVoucherRedemptionApprovals(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      });
    },

    approveVoucherRedemption({commit}, approvalData) {
      return new Promise((resolve, reject) => {
        httpService.approveVoucherRedemption(approvalData)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      });
    }
  }
};
